import type { ReactNode } from "react";

/** Bulleted list styled like the paragraphs of an `nb-doc`. */
export function DocList({ children }: { children: ReactNode }): React.JSX.Element {
  return <ul style={{ margin: "4px 0 0", paddingLeft: 20, listStyle: "disc", color: "var(--ink-muted)" }}>{children}</ul>;
}
